'use client'
import Script from "next/script"

const BlogLdJson = ({ blog }) => {

    let jsonLd = {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: blog.title,
        image: [`${process.env.NEXT_PUBLIC_SHARE_URL}/images/blogcover.jpg`],
        datePublished: blog.createdAt,
        dateModified: blog.updatedAt,
        author: [{
            "@type": "Person",
            "name": "David Ng",
            "url": `${process.env.NEXT_PUBLIC_SHARE_URL}/about`
        }],
    }





         

    return (
        <Script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
            key="product-jsonld"
        />
    )
}

export default BlogLdJson